import request from '@/utils/request'
/**
 * @param {Object} data
 * 根据飞书获取ssoCode
 */
export function getFeiShuCodeLogin(data) {
  return request({
    url: `sso/login/feiShuCodeLogin?ssoCode=${data.ssoCode}&clientId=${data.clientId}&loginType=${data.loginType}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    isLoading: true
  })
}
/**
 * @param {Object} data
 * 获取飞书token
 */
export function getFeiShuToken(data) {
  return request({
    url: `sso/login/token?clientId=${data.clientId}&clientSecret=${data.clientSecret}&ssoCode=${data.ssoCode}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 获取用户信息
 * @param {} data
 * @returns
 */
export function getInfo() {
  return request({
    url: `sso/login/userInfo`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
